/* Kumfy Kids theme JS, original, dependency-free */
(function () {
 'use strict';

 // ---------- helpers ----------
 function $(sel, root) { return (root || document).querySelector(sel); }
 function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
 function money(cents) {
 var c = (cents / 100).toLocaleString(undefined, {
 style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
 });
 return c;
 }
 function escapeHtml(s) {
 return String(s || '').replace(/[&<>"']/g, function (c) {
 return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]);
 });
 }

 // ---------- cart drawer ----------
 var drawer = document.getElementById('cart-drawer');
 var body = drawer && drawer.querySelector('[data-cart-body]');

 function openCart() { drawer && drawer.classList.add('is-open'); drawer && drawer.setAttribute('aria-hidden', 'false'); }
 function closeCart() { drawer && drawer.classList.remove('is-open'); drawer && drawer.setAttribute('aria-hidden', 'true'); }

 $$('[data-cart-open]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); refreshDrawer(); openCart(); }); });
 $$('[data-cart-close]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); closeCart(); }); });
 document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });

 async function refreshDrawer() {
 if (!body) return;
 body.innerHTML = '<div class="drawer__loading">Loading…</div>';
 try {
 var res = await fetch('/cart.js', { credentials: 'same-origin' });
 var cart = await res.json();
 renderCart(cart);
 var counter = document.querySelector('[data-cart-count]');
 if (counter) counter.textContent = cart.item_count;
 } catch (err) {
 body.innerHTML = '<p>Cart unavailable.</p>';
 }
 }

 function renderCart(cart) {
 if (!body) return;
 if (cart.item_count === 0) {
 body.innerHTML = '<div class="drawer__empty"><p>Your bag is empty.</p><a class="btn btn--outline" href="/collections/all">Continue shopping</a></div>';
 return;
 }
 // Free shipping is unconditional now, but we still show a "you saved" line
 var freeShip =
 '<div class="drawer__ship">' +
 '<span>✓ Free shipping on every order</span>' +
 '</div>';
 var lines = cart.items.map(function (it) {
 return (
 '<div class="drawer__line">' +
 '<a href="' + it.url + '"><img src="' + it.image + '" alt="' + escapeHtml(it.product_title) + '"></a>' +
 '<div>' +
 '<a href="' + it.url + '"><strong>' + escapeHtml(it.product_title) + '</strong></a>' +
 '<div class="qty">' + escapeHtml(it.variant_title || '') + '</div>' +
 '<div class="drawer__qty">' +
 '<button type="button" data-line-qty="' + it.key + '" data-delta="-1">−</button>' +
 '<span>' + it.quantity + '</span>' +
 '<button type="button" data-line-qty="' + it.key + '" data-delta="+1">+</button>' +
 '<button type="button" data-line-remove="' + it.key + '" aria-label="Remove">✕</button>' +
 '</div>' +
 '</div>' +
 '<div>' + money(it.final_line_price) + '</div>' +
 '</div>'
 );
 }).join('');
 body.innerHTML =
 freeShip +
 lines +
 '<div class="drawer__sub">' +
 '<span>Subtotal</span><span>' + money(cart.total_price) + '</span>' +
 '</div>' +
 '<div class="drawer__note">Free shipping &amp; 30-day returns included</div>' +
 '<a href="/checkout" class="btn btn--accent drawer__checkout">Checkout · ' + money(cart.total_price) + '</a>' +
 '<a href="/cart" class="drawer__view">View cart</a>' +
 '<div class="drawer__recs" data-cart-recs hidden>' +
 '<div class="drawer__recs-head">You may also like</div>' +
 '<div class="drawer__recs-grid" data-cart-recs-grid></div>' +
 '</div>';

 // wire line controls
 $$('[data-line-qty]', body).forEach(function(b){
 b.addEventListener('click', function(){
 var key = b.dataset.lineQty;
 var delta = parseInt(b.dataset.delta, 10);
 var current = parseInt(b.nextElementSibling.textContent, 10) || 1;
 changeLine(key, Math.max(0, current + delta));
 });
 });
 $$('[data-line-remove]', body).forEach(function(b){
 b.addEventListener('click', function(){ changeLine(b.dataset.lineRemove, 0); });
 });

 // Fetch related products from first cart line
 var firstItem = cart.items[0];
 if (firstItem && firstItem.product_id) {
 var recsEl = body.querySelector('[data-cart-recs]');
 var recsGrid = body.querySelector('[data-cart-recs-grid]');
 var recUrl = '/recommendations/products.json?product_id=' + firstItem.product_id + '&limit=3&intent=related';
 fetch(recUrl, { credentials: 'same-origin' })
.then(function (r) { return r.json(); })
.then(function (data) {
 var items = (data && data.products) || [];
 if (!items.length || !recsGrid) return;
 recsGrid.innerHTML = items.map(function (p) {
 var img = (p.featured_image && (p.featured_image.url || p.featured_image)) || '';
 return (
 '<a class="drawer__rec" href="' + p.url + '">' +
 '<div class="drawer__rec-media">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</div>' +
 '<div class="drawer__rec-title">' + escapeHtml(p.title) + '</div>' +
 '<div class="drawer__rec-price">' + money(p.price || p.price_min || 0) + '</div>' +
 '</a>'
 );
 }).join('');
 recsEl.hidden = false;
 })
.catch(function () {});
 }
 }
 async function changeLine(key, qty){
 try {
 var r = await fetch('/cart/change.js', {
 method: 'POST',
 headers: { 'Content-Type': 'application/json' },
 body: JSON.stringify({ id: key, quantity: qty }),
 credentials: 'same-origin'
 });
 if (r.ok) refreshDrawer();
 } catch (err) {}
 }

 // ---------- product form (AJAX add) ----------
 $$('form[data-product-form]').forEach(function (form) {
 form.addEventListener('submit', async function (e) {
 e.preventDefault();
 var btn = form.querySelector('[type=submit]');
 if (btn) btn.disabled = true;
 try {
 var data = new FormData(form);
 var res = await fetch('/cart/add.js', { method: 'POST', body: data, credentials: 'same-origin' });
 if (!res.ok) throw new Error(await res.text());
 refreshDrawer();
 openCart();
 } catch (err) {
 alert('Could not add to cart. Please try again.');
 } finally {
 if (btn) btn.disabled = false;
 }
 });
 });

 // ---------- variant selector (swatch-based) ----------
 $$('[data-variant-selector]').forEach(function (root) {
 var variants;
 try { variants = JSON.parse(root.dataset.variants || '[]'); } catch (_) { variants = []; }
 var hidden = root.querySelector('[data-variant-id]');
 var swatches = $$('[data-option-input]', root);
 var priceEl = root.querySelector('[data-product-price]') || document.querySelector('[data-product-price]');
 var ctaPrice = root.querySelector('[data-cta-price]');
 var stockEl = document.querySelector('[data-stock-line]');
 var addLabel = root.querySelector('[data-add-label]');

 function currentValues() {
 var values = [];
 $$('[data-option-hidden]', root).forEach(function (h) {
 values[parseInt(h.dataset.optionHidden, 10)] = h.value;
 });
 return values;
 }
 function matchVariant() {
 var chosen = currentValues();
 return variants.find(function (v) {
 return v.options.every(function (o, i) { return o === chosen[i]; });
 });
 }
 function updateUI() {
 var v = matchVariant();
 if (!v) return;
 if (hidden) hidden.value = v.id;
 var price = money(v.price);
 var compare = v.compare_at_price && v.compare_at_price > v.price ? money(v.compare_at_price) : null;
 if (priceEl) {
 priceEl.innerHTML = (compare ? '<del>' + compare + '</del> ' : '') +
 '<ins>' + price + '</ins>';
 }
 if (ctaPrice) ctaPrice.textContent = price;
 if (addLabel && !v.available) {
 addLabel.textContent = 'Sold out';
 root.querySelectorAll('[type=submit]').forEach(function (b) { b.disabled = true; });
 } else if (addLabel) {
 addLabel.innerHTML = 'Add to bag, <span data-cta-price>' + price + '</span>';
 root.querySelectorAll('[type=submit]').forEach(function (b) { b.disabled = false; });
 }
 if (stockEl) {
 if (v.available) {
 if (v.inventory_quantity > 0 && v.inventory_quantity < 10) {
 stockEl.textContent = '⚡ Only ' + v.inventory_quantity + ' left in stock';
 } else {
 stockEl.textContent = '✓ In stock, ships in 1-2 business days';
 }
 } else {
 stockEl.textContent = '✕ Currently unavailable';
 }
 }
 }

 // Swatch click → update active state + hidden value
 swatches.forEach(function (sw) {
 sw.addEventListener('click', function () {
 var idx = parseInt(sw.dataset.optionIdx, 10);
 // remove active from siblings
 sw.parentElement.querySelectorAll('[data-option-input]').forEach(function (s) {
 s.classList.remove('is-active');
 });
 sw.classList.add('is-active');
 var hiddenInput = root.querySelector('[data-option-hidden="' + idx + '"]');
 if (hiddenInput) hiddenInput.value = sw.dataset.value;
 var label = root.querySelector('[data-option-display="' + idx + '"]');
 if (label) label.textContent = sw.dataset.value;
 updateUI();
 });
 });

 updateUI();
 });

 // ---------- quantity stepper ----------
 $$('.pdp__qty-stepper').forEach(function (s) {
 var input = s.querySelector('input');
 $$('button', s).forEach(function (b) {
 b.addEventListener('click', function () {
 var delta = parseInt(b.dataset.qty || '1', 10);
 var v = Math.max(1, (parseInt(input.value, 10) || 1) + delta);
 input.value = v;
 });
 });
 });

 // ---------- gallery (PDP) ----------
 $$('[data-gallery]').forEach(function (gallery) {
 var thumbs = $$('.pdp__thumb', gallery);
 var mains = $$('.pdp__main-link', gallery);
 thumbs.forEach(function (t) {
 t.addEventListener('click', function () {
 var i = t.dataset.idx;
 thumbs.forEach(function (x) { x.classList.toggle('is-active', x.dataset.idx === i); });
 mains.forEach(function (m) { m.classList.toggle('is-active', m.dataset.idx === i); });
 });
 });
 });

 // ---------- tabbed product carousel ----------
 $$('.tabbed').forEach(function (root) {
 var tabs = $$('.tabbed__pill', root);
 var panels = $$('.tabbed__panel', root);
 tabs.forEach(function (t) {
 t.addEventListener('click', function () {
 var id = t.dataset.tabId;
 tabs.forEach(function (x) {
 x.classList.toggle('is-active', x === t);
 x.setAttribute('aria-selected', x === t ? 'true' : 'false');
 });
 panels.forEach(function (p) {
 p.classList.toggle('is-active', p.dataset.panel === id);
 });
 });
 });
 });

 // ---------- Split hero (mobile dots ↔ scroll) ----------
 $$('[data-split-hero-wrap]').forEach(function (wrap) {
 var track = wrap.querySelector('[data-split-hero]');
 var dots = $$('[data-sh-dot]', wrap);
 if (!track || dots.length < 2) return;
 function syncDots() {
 var w = track.clientWidth || 1;
 var idx = Math.round(track.scrollLeft / w);
 dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
 }
 track.addEventListener('scroll', function () { window.requestAnimationFrame(syncDots); }, { passive: true });
 dots.forEach(function (d, i) {
 d.addEventListener('click', function () {
 track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
 });
 });
 });

 // ---------- CTA carousel ----------
 $$('[data-cta-slider]').forEach(function (root) {
 var slides = $$('[data-cta-slide]', root);
 var dots = $$('[data-cta-dot]', root);
 if (!slides.length) return;
 slides[0].classList.add('is-active');
 var current = 0;
 function go(i) {
 current = (i + slides.length) % slides.length;
 slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === current); });
 dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === current); });
 }
 dots.forEach(function (d, idx) {
 d.addEventListener('click', function () { go(idx); restart(); });
 });
 var interval = parseFloat(root.dataset.autoplay || '0') * 1000;
 var timer = null;
 function restart() {
 if (timer) clearInterval(timer);
 if (interval > 500) timer = setInterval(function () { go(current + 1); }, interval);
 }
 restart();
 });

 // ---------- Collection page: filters, view, quick add ----------
 // Client-side filtering. Reads sidebar inputs and toggles.is-hidden on cards.
 function applyCollFilters() {
 var sizes = $$('input[data-filter="size"]:checked').map(function (i) { return i.value.toLowerCase(); });
 var types = $$('input[data-filter="type"]:checked').map(function (i) { return i.value.toLowerCase(); });
 var genders = $$('input[data-filter="gender"]:checked').map(function (i) { return i.value.toLowerCase(); });
 var avails = $$('input[data-filter="avail"]:checked').map(function (i) { return i.value; });
 var pmin = parseFloat(document.querySelector('input[data-filter="price-min"]') ? document.querySelector('input[data-filter="price-min"]').value : '') || -Infinity;
 var pmax = parseFloat(document.querySelector('input[data-filter="price-max"]') ? document.querySelector('input[data-filter="price-max"]').value : '') || Infinity;

 var cards = $$('[data-card]');
 var visible = 0;
 cards.forEach(function (card) {
 var ok = true;
 if (sizes.length) {
 var cardSizes = (card.dataset.sizes || '').toLowerCase().split(',').filter(Boolean);
 ok = ok && sizes.some(function (s) { return cardSizes.indexOf(s) > -1; });
 }
 if (ok && types.length) {
 ok = types.indexOf((card.dataset.type || '').toLowerCase()) > -1;
 }
 if (ok && genders.length) {
 var ts = (card.dataset.tags || '').toLowerCase().split(',');
 ok = genders.some(function (g) {
 return ts.indexOf(g) > -1 || ts.indexOf(g + 's') > -1;
 });
 }
 if (ok && avails.length) {
 var avail = card.dataset.available === '1';
 ok = (avails.indexOf('in') > -1 && avail) || (avails.indexOf('out') > -1 && !avail);
 }
 if (ok) {
 var price = parseFloat(card.dataset.price || '0');
 ok = price >= pmin && price <= pmax;
 }
 card.classList.toggle('is-hidden', !ok);
 if (ok) visible++;
 });

 var counter = document.querySelector('[data-count]');
 if (counter) counter.textContent = visible;
 var empty = document.querySelector('[data-empty]');
 if (empty) empty.hidden = visible !== 0;
 }
 $$('input[data-filter]').forEach(function (input) {
 input.addEventListener('change', applyCollFilters);
 input.addEventListener('input', applyCollFilters);
 });
 // Clear all filters
 $$('[data-filter-reset]').forEach(function (b) {
 b.addEventListener('click', function () {
 $$('input[data-filter]').forEach(function (i) {
 if (i.type === 'checkbox') i.checked = false;
 if (i.type === 'number' && i.dataset.filter === 'price-min') i.value = i.placeholder;
 if (i.type === 'number' && i.dataset.filter === 'price-max') i.value = i.placeholder;
 });
 applyCollFilters();
 });
 });
 // Sidebar collapse/expand
 $$('[data-coll-toggle]').forEach(function (b) {
 b.addEventListener('click', function () {
 var side = $('[data-coll-side]');
 var main = $('.coll-main');
 var open = side.classList.toggle('is-hidden');
 b.setAttribute('aria-expanded', !open);
 b.classList.toggle('is-open', !open);
 if (main) main.classList.toggle('is-wide', open);
 });
 });
 // Filter group collapse
 $$('[data-filter-toggle]').forEach(function (h) {
 var parent = h.parentElement;
 h.addEventListener('click', function () {
 var open = parent.classList.toggle('is-collapsed');
 h.setAttribute('aria-expanded', !open);
 });
 });
 // "Show more" inside a filter
 $$('[data-filter-more]').forEach(function (b) {
 b.addEventListener('click', function () {
 var more = b.previousElementSibling;
 if (more) more.hidden = !more.hidden;
 b.textContent = more && more.hidden ? 'Show more' : 'Show less';
 });
 });
 // View toggles (2/3/4 columns)
 $$('[data-view]').forEach(function (btn) {
 btn.addEventListener('click', function () {
 var cols = btn.dataset.view;
 var grid = document.querySelector('[data-coll-grid]');
 if (grid) grid.style.setProperty('--cols', cols);
 $$('[data-view]').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
 try { localStorage.setItem('kumfykids_coll_view', cols); } catch (e) {}
 });
 });
 // Restore view from storage
 try {
 var savedView = localStorage.getItem('kumfykids_coll_view');
 if (savedView) {
 var grid = document.querySelector('[data-coll-grid]');
 if (grid) grid.style.setProperty('--cols', savedView);
 $$('[data-view]').forEach(function (b) { b.classList.toggle('is-active', b.dataset.view === savedView); });
 }
 } catch (e) {}
 // Quick add
 $$('[data-quick-add]').forEach(function (btn) {
 btn.addEventListener('click', async function (e) {
 e.preventDefault();
 var id = btn.dataset.quickAdd;
 if (!id) return;
 btn.disabled = true;
 var prev = btn.textContent;
 btn.textContent = '✓';
 try {
 await fetch('/cart/add.js', {
 method: 'POST', headers: { 'Content-Type': 'application/json' },
 body: JSON.stringify({ id: parseInt(id, 10), quantity: 1 }),
 credentials: 'same-origin'
 });
 if (typeof refreshDrawer === 'function') refreshDrawer();
 var d = document.getElementById('cart-drawer');
 if (d) d.classList.add('is-open');
 setTimeout(function () { btn.textContent = prev; btn.disabled = false; }, 700);
 } catch (err) {
 btn.textContent = prev; btn.disabled = false;
 alert('Could not add to cart.');
 }
 });
 });

 // ---------- Product card color swatch hover swaps image ----------
 $$('.product-card').forEach(function (card) {
 var front = card.querySelector('.product-card__img--front');
 if (!front) return;
 var originalSrc = front.src;
 $$('.product-card__sw', card).forEach(function (sw) {
 var src = sw.dataset.swImg;
 if (!src) return;
 sw.addEventListener('mouseenter', function () { front.src = src; });
 sw.addEventListener('mouseleave', function () { front.src = originalSrc; });
 sw.addEventListener('click', function (e) { e.preventDefault(); originalSrc = src; front.src = src; });
 });
 });

 // ---------- Predictive search modal ----------
 var sModal = document.querySelector('[data-search-modal]');
 var sInput = sModal && sModal.querySelector('[data-search-input]');
 var sResults = sModal && sModal.querySelector('[data-search-results]');
 function openSearch(){ if (sModal) { sModal.classList.add('is-open'); sModal.setAttribute('aria-hidden','false'); setTimeout(function(){ sInput && sInput.focus(); }, 50); } }
 function closeSearch(){ if (sModal) { sModal.classList.remove('is-open'); sModal.setAttribute('aria-hidden','true'); } }
 $$('[data-search-open]').forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); openSearch(); }); });
 $$('[data-search-close]').forEach(function(b){ b.addEventListener('click', function(){ closeSearch(); }); });
 document.addEventListener('keydown', function(e){ if (e.key === 'Escape') closeSearch(); });

 var searchTimer = null;
 if (sInput) {
 sInput.addEventListener('input', function(){
 var q = sInput.value.trim();
 if (searchTimer) clearTimeout(searchTimer);
 if (q.length < 2) {
 sResults.innerHTML = '<div class="search-modal__suggested"><h4>Popular searches</h4><div class="search-modal__chips">' +
 ['dress','cardigan','overall','bonnet','baby','sale'].map(function(t){return '<a href="/search?q='+t+'">'+t+'</a>';}).join('') +
 '</div></div>';
 return;
 }
 searchTimer = setTimeout(function(){
 var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
 '&resources[type]=product,collection&resources[limit]=8&resources[options][fields]=title,product_type,variants.title';
 fetch(url, { headers: { 'Accept': 'application/json' } })
.then(function(r){ return r.json(); })
.then(function(j){
 var products = (j.resources && j.resources.results && j.resources.results.products) || [];
 var colls = (j.resources && j.resources.results && j.resources.results.collections) || [];
 if (!products.length && !colls.length) {
 sResults.innerHTML = '<p class="search-modal__empty">No results for "<strong>' + escapeHtml(q) + '</strong>". Try a different search.</p>';
 return;
 }
 var html = '';
 if (colls.length) {
 html += '<h4>Collections</h4><div class="search-modal__chips">' +
 colls.map(function(c){ return '<a href="' + c.url + '">' + escapeHtml(c.title) + '</a>'; }).join('') +
 '</div>';
 }
 if (products.length) {
 html += '<h4>Products</h4><div class="search-modal__products">' +
 products.map(function(p){
 return '<a class="search-prod" href="' + p.url + '">' +
 (p.image ? '<img loading="lazy" src="' + p.image + '" alt="">' : '<span class="search-prod__noimg"></span>') +
 '<div><strong>' + escapeHtml(p.title) + '</strong><span>' + (p.price || '') + '</span></div>' +
 '</a>';
 }).join('') +
 '</div>';
 html += '<a class="search-modal__viewall" href="/search?q=' + encodeURIComponent(q) + '">View all results →</a>';
 }
 sResults.innerHTML = html;
 })
.catch(function(){
 sResults.innerHTML = '<p class="search-modal__empty">Search unavailable. Press enter to use the full search.</p>';
 });
 }, 220);
 });
 }

 // ---------- Sticky add-to-cart bar (PDP) ----------
 var stickyBar = document.querySelector('[data-sticky-bar]');
 var stickyTarget = document.querySelector('.pdp__add');
 if (stickyBar && stickyTarget) {
 var io = new IntersectionObserver(function(entries){
 entries.forEach(function(e){
 stickyBar.classList.toggle('is-visible', !e.isIntersecting);
 });
 }, { threshold: 0 });
 io.observe(stickyTarget);
 var stickyAddBtn = stickyBar.querySelector('[data-sticky-add]');
 if (stickyAddBtn) {
 stickyAddBtn.addEventListener('click', function(){
 var form = document.querySelector('form[data-product-form]');
 if (form) {
 form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
 }
 });
 }
 }

 // ---------- Dual-handle price range slider ----------
 $$('[data-price-slider]').forEach(function (slider) {
 var lo = parseFloat(slider.dataset.lo || '0');
 var hi = parseFloat(slider.dataset.hi || '100');
 var minR = slider.querySelector('[data-range-min]');
 var maxR = slider.querySelector('[data-range-max]');
 var fill = slider.querySelector('[data-fill]');
 var minN = document.querySelector('input[data-filter="price-min"]');
 var maxN = document.querySelector('input[data-filter="price-max"]');
 if (!minR || !maxR) return;

 function clamp(n, a, b) { return Math.max(a, Math.min(b, n)); }
 function pct(v) { return ((v - lo) / (hi - lo)) * 100; }

 function sync(source) {
 var a = parseFloat(minR.value);
 var b = parseFloat(maxR.value);
 if (source === 'min' && a > b) { minR.value = b; a = b; }
 if (source === 'max' && b < a) { maxR.value = a; b = a; }
 fill.style.left = pct(a) + '%';
 fill.style.right = (100 - pct(b)) + '%';
 if (minN) minN.value = Math.round(a);
 if (maxN) maxN.value = Math.round(b);
 }

 function fromNumbers() {
 var a = clamp(parseFloat(minN ? minN.value : lo) || lo, lo, hi);
 var b = clamp(parseFloat(maxN ? maxN.value : hi) || hi, lo, hi);
 if (a > b) a = b;
 minR.value = a; maxR.value = b;
 fill.style.left = pct(a) + '%';
 fill.style.right = (100 - pct(b)) + '%';
 }

 minR.addEventListener('input', function () { sync('min'); });
 maxR.addEventListener('input', function () { sync('max'); });
 minR.addEventListener('change', function () { if (typeof applyCollFilters === 'function') applyCollFilters(); });
 maxR.addEventListener('change', function () { if (typeof applyCollFilters === 'function') applyCollFilters(); });
 if (minN) minN.addEventListener('input', fromNumbers);
 if (maxN) maxN.addEventListener('input', fromNumbers);
 sync();
 });

 // ---------- mobile drawer ----------
 var mDrawer = document.querySelector('[data-mobile-drawer]');
 if (mDrawer) {
 $$('[data-mobile-open]').forEach(function (b) {
 b.addEventListener('click', function () { mDrawer.classList.add('is-open'); mDrawer.setAttribute('aria-hidden', 'false'); });
 });
 $$('[data-mobile-close]').forEach(function (b) {
 b.addEventListener('click', function () { mDrawer.classList.remove('is-open'); mDrawer.setAttribute('aria-hidden', 'true'); });
 });
 }

 // ---------- reveal-on-scroll ----------
 if ('IntersectionObserver' in window) {
 var obs = new IntersectionObserver(function (entries) {
 entries.forEach(function (e) {
 if (e.isIntersecting) { e.target.classList.add('in-view'); obs.unobserve(e.target); }
 });
 }, { threshold: 0.12 });
 $$('[data-reveal]').forEach(function (el) { obs.observe(el); });
 }
})();
